import React from 'react'
import './optionsHeader.scss'

interface OptionsHeaderProps extends React.HTMLAttributes<HTMLElement> {
    filteredOptionsCount?: number
    totalOptionsCount?: number
    selectedCount?: number
    allFilteredOptionsSelected?: boolean
    onSelectAll?: () => void
    onDeselectAll?: () => void
}

const OptionsHeader = (props: OptionsHeaderProps) => {
    const {
        filteredOptionsCount = 0,
        totalOptionsCount = 0,
        selectedCount = 0,
        allFilteredOptionsSelected = false,
        onSelectAll,
        onDeselectAll,
    } = props

    const handleButtonClick = () => {
        if (allFilteredOptionsSelected) {
            onDeselectAll?.()
        } else {
            onSelectAll?.()
        }
    }

    const actionText = allFilteredOptionsSelected ? 'Deselect' : 'Select'
    const amountText =
        filteredOptionsCount === totalOptionsCount
            ? `all (${totalOptionsCount})`
            : `${filteredOptionsCount} (out of ${totalOptionsCount} total)`
    const buttonText = `${actionText} ${amountText}`

    return filteredOptionsCount > 0 ? (
        <button className="combobox-options-header" onClick={handleButtonClick} type="button">
            <div className="combobox-selection-text">{buttonText}</div>
            {selectedCount > 0 && <span className="combobox-selected-count">{selectedCount} selected</span>}
        </button>
    ) : null
}

export default OptionsHeader
